import { render, staticRenderFns } from "./developPage_view.vue?vue&type=template&id=5722e485&scoped=true&"
import script from "./developPage_view.vue?vue&type=script&lang=js&"
export * from "./developPage_view.vue?vue&type=script&lang=js&"
import style0 from "./developPage_view.vue?vue&type=style&index=0&id=5722e485&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5722e485",
  null
  
)

export default component.exports